// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3f81K","rootNoMargin":"styles_rootNoMargin__3T3bR"};